<template>
  <div>

    <button
      v-for="(identifier, i) in identifiers"
      :key="'identifiers-' + i"
      type="button"
      class="btn text-xs mb-1"
      :class="[selected.identifier === identifier.key ? 'btn-green' : 'bg-theme-200 light:bg-theme-600', i < identifiers.length - 1 ? 'mr-1' : '']"
      @click="select(identifier.key)"
    >{{ identifier.display }}</button>

  </div>
</template>

<script>
export default {
  props: {
    identifier: String,
  },
  data() {
    return {
      identifiers: [
        {key: 'current-month', display: 'Current month'},
        {key: 'previous-month', display: 'Previous month'},
        {key: 'last-30-days', display: 'Last 30 days'},
        {key: 'last-6-month', display: 'Last 6 months'},
        {key: 'current-year', display: 'Current year'},
        {key: 'last-year', display: 'Last year'},
      ],
      selected: {
        identifier: '',
        value: '',
      },
    }
  },
  watch: {
    identifier() {
      this.select(this.identifier)
    }
  },
  mounted() {
    if (this.identifier) {
      this.select(this.identifier)
    }
  },
  methods: {
    select(identifier) {
      this.selected.identifier = identifier
      this.selected.value = this.$getDateRangeByIdentifier(identifier)
      this.$emit('update:identifier', identifier)
      this.$emit('input', this.selected.value)
    }
  }
}
</script>
